import { useCurrentStateAndParams } from "@uirouter/react";

import { useGetCompanyInfo } from "app/pages/sales-intelligence/modules/ai-agent/queries/useGetCompanyInfo";

type CompanyNameState = {
    companyName: string;
    // False while the previous domain's company is still shown as placeholder data
    isReady: boolean;
};

export const useCompanyName = (): CompanyNameState => {
    const {
        params: { domain },
    } = useCurrentStateAndParams<{ domain: string }>();

    const { data: companyData, isPlaceholderData } = useGetCompanyInfo(domain);

    return {
        companyName: companyData?.companyName ?? "",
        isReady: Boolean(companyData) && !isPlaceholderData,
    };
};
